import Command from '@ckeditor/ckeditor5-core/src/command';
import { CkeditorConstants } from "../../src/utils";

const {
  PLUGINS: { CONTEXTUAL_BALLOON }
} = CkeditorConstants;

export default class CitationCommand extends Command {
  execute() {
    this.editor.fire('citation');
    this.isEnabled = false;
    this.refresh();
  }
  refresh() {
    this.listenTo(this.editor.editing.view.document, 'click', () => {
      this.enableDisablePlugin();
    });
    this.listenTo(this.editor.editing.view.document, 'change', () => {
      this.enableDisablePlugin();
    });
    this.editor.ui.view.toolbar.element.addEventListener('click', () => {
      this.editor.plugins?.get?.(CONTEXTUAL_BALLOON).view.hide();
    });
  }

  enableDisablePlugin() {
    if (this.editor.model.document.selection.getSelectedElement() === null) {
      this.isEnabled = true;
    } else {
      this.isEnabled = false;
    }
  }
}
